var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import 'rc-dropdown/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import _debounce from 'lodash/debounce';
import _throttle from 'lodash/throttle';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Icon } from '@material-ui/core';
import { prefixExReact } from '../../../helpers/components';
import { localeSelector } from '../../../store/selectors/locale';
import { tokenization } from './suggestion-service';
var Container = styled.div.attrs(function () { return ({
    className: prefixExReact('peachbar'),
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var ModelSelect = styled.button.attrs(function () { return ({
    className: prefixExReact('peachbar-select'),
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 1px solid #aeaeae;\n  min-width: 100px;\n  border-radius: 4px 0 0 4px;\n  display: flex;\n  text-align: center;\n  align-items: center;\n  padding: 4px 16px;\n  margin: 0;\n  background: #282283 0% 0% no-repeat padding-box !important;\n  color: #ffffff;\n  letter-spacing: 0.17px;\n  height: 42px;\n  > span:first-child {\n    flex-grow: 1;\n    margin-right: '16px';\n  }\n"], ["\n  border: 1px solid #aeaeae;\n  min-width: 100px;\n  border-radius: 4px 0 0 4px;\n  display: flex;\n  text-align: center;\n  align-items: center;\n  padding: 4px 16px;\n  margin: 0;\n  background: #282283 0% 0% no-repeat padding-box !important;\n  color: #ffffff;\n  letter-spacing: 0.17px;\n  height: 42px;\n  > span:first-child {\n    flex-grow: 1;\n    margin-right: '16px';\n  }\n"])));
var SearchButton = styled.button.attrs(function () { return ({
    className: prefixExReact('peachbar-searchbtn'),
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  background: #282283 0% 0% no-repeat padding-box !important;\n  box-shadow: 0px 0px 8px #0000004d;\n  opacity: 1;\n  border-radius: 50%;\n  color: #ffffff;\n  margin-left: -21px;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  background: #282283 0% 0% no-repeat padding-box !important;\n  box-shadow: 0px 0px 8px #0000004d;\n  opacity: 1;\n  border-radius: 50%;\n  color: #ffffff;\n  margin-left: -21px;\n  align-items: center;\n"])));
var SearchInput = styled.input.attrs(function () { return ({
    className: prefixExReact('peachbar-input'),
}); })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-color: #aeaeae;\n  flex-grow: 1;\n  border-left: 0;\n  border-right: 0;\n  border-radius: 0;\n  margin: 0;\n"], ["\n  border-color: #aeaeae;\n  flex-grow: 1;\n  border-left: 0;\n  border-right: 0;\n  border-radius: 0;\n  margin: 0;\n"])));
var SuggestionsMenu = styled(Menu).attrs(function () { return ({
    className: prefixExReact('peachbar-suggestions-menu'),
}); })(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var Suggestion = styled(MenuItem).attrs(function () { return ({
    className: prefixExReact('peachbar-suggestions-item'),
}); })(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
var Calendar = styled(DatePicker).attrs(function () { return ({
    className: prefixExReact('peachbar-calendar'),
}); })(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
var UserLoginLabel = styled.div.attrs(function () { return ({
    className: prefixExReact('peachbar-userlogin-label'),
}); })(templateObject_8 || (templateObject_8 = __makeTemplateObject([""], [""])));
var getTextWidth = function (inputEl, cursorPos) {
    var value = inputEl.value;
    var text = value.substring(0, cursorPos);
    var span = document.createElement('span');
    span.style.fontSize = inputEl.style.fontSize;
    span.style.fontFamily = inputEl.style.fontFamily;
    span.style.fontWeight = inputEl.style.fontWeight;
    span.style.visibility = 'hidden';
    document.body.appendChild(span);
    span.innerHTML = text.replace(/\s/g, '&nbsp;');
    console.log('[getTextWidth]', { span: span, text: text });
    var textWidth = span.offsetWidth;
    document.body.removeChild(span);
    console.log('[getTextWidth]', { textWidth: textWidth });
    return textWidth;
};
var PeachBar = function (props) {
    var inputRef = useRef();
    var search = props.search, queryModels = props.queryModels, searchButtonProps = props.searchButtonProps, searchOnEnter = props.searchOnEnter, onSelectQueryModel = props.onSelectQueryModel, userSearchTableProps = props.userSearchTableProps, renderCustomUserSearchTable = props.renderCustomUserSearchTable, userLoginSuggestionLabel = props.userLoginSuggestionLabel, throttle = props.throttle, delay = props.delay, delayOptions = props.delayOptions, restProps = __rest(props, ["search", "queryModels", "searchButtonProps", "searchOnEnter", "onSelectQueryModel", "userSearchTableProps", "renderCustomUserSearchTable", "userLoginSuggestionLabel", "throttle", "delay", "delayOptions"]);
    var searchState = search.state, updateQuery = search.updateQuery, selectModel = search.selectModel, performSearch = search.performSearch;
    var lang = useSelector(localeSelector()).lang;
    var language = lang;
    var t = useTranslation().t;
    var _a = useState(function () { return ({
        inputCursorPos: 0,
        textWidth: 0,
        suggestions: [],
        selectedDate: new Date(),
        searchUserLogin: false,
        delayFunction: throttle ? _throttle : _debounce,
    }); }), state = _a[0], setState = _a[1];
    var handleSuggestionClick = function (suggestion, forceUpdate) {
        if (forceUpdate === void 0) { forceUpdate = false; }
        var text = suggestion.label;
        var length = text ? text.length : 0;
        var start = suggestion.start === 0 ? 0 : suggestion.start + 1;
        var classType = suggestion.class;
        var nonReplaceableClassTypes = [
            'calendar',
            'userLogin',
            'activityOperation',
        ];
        console.log('[PeachBar] handleSuggestionClick', {
            suggestion: suggestion,
            forceUpdate: forceUpdate,
        });
        if (forceUpdate || nonReplaceableClassTypes.indexOf(classType) < 0) {
            var textArr = searchState.query.split('');
            textArr.splice(start, length, text);
            var newText = textArr.join('');
            console.log('[handleSuggestionClick]', { suggestion: suggestion, newText: newText });
            updateQuery(newText);
        }
        setTimeout(function () {
            console.log('[PeachBar] handleSuggestionClick auto focus');
            inputRef.current.focus();
        }, 100);
    };
    var onDateSelected = function (date, suggestion) {
        var dateString = moment.tz(date, moment.tz.guess()).format('YYYY-MM-DD');
        console.log('[PeachBar] onDateSelected', { date: date, suggestion: suggestion, dateString: dateString });
        handleSuggestionClick(__assign(__assign({}, suggestion), { text: dateString }), true);
        setState(function (prevState) { return (__assign(__assign({}, prevState), { selectedDate: date })); });
        var newText = "" + searchState.query + dateString;
        updateQuery(newText);
    };
    var onUserLoginOption = function (evt, suggestion) {
        console.log('[PeachBar] onUserLoginOption', { evt: evt, suggestion: suggestion });
        setState(function (prevState) { return (__assign(__assign({}, prevState), { searchUserLogin: suggestion })); });
        setTimeout(function () { return inputRef.current.blur(); }, 10);
        evt.stopPropagation();
    };
    var getSuggestionLabel = function (suggestion) {
        switch (suggestion.class) {
            case 'calendar':
                return (React.createElement(Calendar, { selected: state.selectedDate, onChange: function (date) { return onDateSelected(date, suggestion); }, inline: true, todayButton: t('Today') }));
            case 'userLogin':
                return (React.createElement(UserLoginLabel, { onClick: function (evt) { return onUserLoginOption(evt, suggestion); } }, "Pick User"));
            default:
                return suggestion.label;
        }
    };
    var getInputCursorPos = function (evt, offset) {
        if (offset === void 0) { offset = 0; }
        var input = inputRef.current;
        var selectionStart = input.selectionStart, selectionEnd = input.selectionEnd;
        console.log('[PeachBar] getInputCursorPos', {
            input: input,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd,
            offset: offset,
        });
        setState(function (prevState) { return (__assign(__assign({}, prevState), { inputCursorPos: selectionStart + offset })); });
    };
    var handleFocus = function () {
        var queryLength = search.state.query.length;
        inputRef.current.setSelectionRange(queryLength, queryLength);
        getInputCursorPos(null);
    };
    var handleInputKeyDown = function (evt) {
        if (evt.key === 'Enter' && searchOnEnter) {
            performSearch();
        }
        if (evt.key === 'ArrowRight' || evt.key === 'ArrowLeft') {
            var offsets = {
                ArrowRight: 1,
                ArrowLeft: -1,
            };
            getInputCursorPos(evt, offsets[evt.key]);
        }
    };
    var handleInputChange = function () {
        var value = inputRef.current.value;
        getInputCursorPos(null);
        updateQuery(value);
    };
    var getSuggestionsMenu = function () {
        var suggestions = state.suggestions;
        console.log('[PeachBar] getSuggestionsMenu', { suggestions: suggestions });
        var suggestionElements = [];
        var _loop_1 = function (key) {
            var suggestion = suggestions[key];
            suggestionElements.push(React.createElement(Suggestion, { key: suggestion.class + "_" + suggestion.label, onClick: function () { return handleSuggestionClick(suggestion); } }, getSuggestionLabel(suggestion)));
        };
        for (var key in suggestions) {
            _loop_1(key);
        }
        return React.createElement(SuggestionsMenu, null, suggestionElements);
    };
    var dispatchGetPeachSuggestions = function (state, searchState) {
        var inputCursorPos = state.inputCursorPos;
        var query = searchState.query, selectedModel = searchState.selectedModel, transformedFields = searchState.transformedFields;
        console.log({ searchState: searchState, state: state });
        console.log('[PeachBar] dispatchGetPeachSuggestions', {
            transformedFields: transformedFields,
            inputCursorPos: inputCursorPos,
            query: query,
            selectedModel: selectedModel,
        });
        var suggestions = tokenization({
            input: transformedFields,
            query: query,
            language: language,
            cursorPosition: inputCursorPos,
        });
        console.log({ language: language, suggestions: suggestions });
        setState(function (prevState) { return (__assign(__assign({}, prevState), { suggestions: suggestions })); });
    };
    var retrieveSuggestions = useRef(state.delayFunction(dispatchGetPeachSuggestions, delay, delayOptions));
    var handleModelMenuClick = function (model) {
        selectModel(model);
        onSelectQueryModel(model);
    };
    useEffect(function () {
        console.log('[PeachBar] effect inputCursorPos change', {
            inputCursorPos: state.inputCursorPos,
            query: search.state.query,
        });
        retrieveSuggestions.current(state, searchState);
        setState(function (prevState) { return (__assign(__assign({}, prevState), { textWidth: getTextWidth(inputRef.current, state.inputCursorPos) })); });
    }, [state.inputCursorPos, search.state.query, searchState.transformedFields]);
    useEffect(function () {
        retrieveSuggestions.current(state, searchState);
    }, [language]);
    var ModelsMenu = (React.createElement(Menu, null, queryModels.map(function (model) { return (React.createElement(MenuItem, { key: model.key || model.alias, onClick: function () { return handleModelMenuClick(model); } }, t(model.label, model.labelParams))); })));
    return (React.createElement(Container, __assign({}, restProps),
        React.createElement(Dropdown, { overlay: ModelsMenu, trigger: queryModels.length > 1 ? ['click'] : [] },
            React.createElement(ModelSelect, null,
                React.createElement("span", null, t(searchState.selectedModel.label, searchState.selectedModel.labelParams)),
                queryModels.length > 1 ? React.createElement(Icon, null, "keyboard_arrow_down") : null)),
        React.createElement(Dropdown, { overlay: getSuggestionsMenu, minOverlayWidthMatchTrigger: false, trigger: ['focus'], align: { offset: [state.textWidth, 0] } },
            React.createElement(SearchInput, { ref: inputRef, value: searchState.query, onChange: handleInputChange, onClick: getInputCursorPos, onKeyDown: handleInputKeyDown, onFocus: handleFocus })),
        React.createElement(SearchButton, __assign({}, searchButtonProps, { onClick: function () { return performSearch(); } }))));
};
PeachBar.propTypes = {
    queryModels: PropTypes.arrayOf(PropTypes.shape({
        alias: PropTypes.string,
        label: PropTypes.string,
    })).isRequired,
    search: PropTypes.object.isRequired,
    searchButtonProps: PropTypes.object,
    searchOnEnter: PropTypes.bool,
    onSelectQueryModel: PropTypes.func,
    userSearchTableProps: PropTypes.object,
    renderCustomUserSearchTable: PropTypes.func,
    userLoginSuggestionLabel: PropTypes.any,
    throttle: PropTypes.bool,
    delay: PropTypes.number,
    delayOptions: PropTypes.object,
};
PeachBar.defaultProps = {
    searchButtonProps: {
        children: React.createElement(Icon, null, "search"),
    },
    searchOnEnter: true,
    onSelectQueryModel: function () { },
    userSearchTableProps: {},
    throttle: false,
    delay: 300,
};
export default PeachBar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=index.js.map